<script src="rule-duplicate-warning.component.ts"></script>

<div class="success-modal">
  <div>
    <h2 [innerHtml]='message'></h2>
  </div>
  <app-spinner *ngIf="loading"></app-spinner>
  <md-dialog-content *ngIf="!loading">

    <table>
      <thead>
        <tr>
          <th *ngIf="!mode">&nbsp;</th>
          <th *ngIf="rule && mode === 'update'" class="header">
            <md-checkbox name="selectAll" color="accent" (change)="selectAll()" [checked]="allAreSelected()"
              mdTooltip="Select All"></md-checkbox> Action
          </th>
          <th *ngIf="rule && mode === 'delete'" class="header">
            <md-checkbox name="selectAll" color="accent" (change)="selectAll()" [checked]="allAreSelected()"
              mdTooltip="Select All"></md-checkbox> Selection
          </th>
          <th>Id</th>
          <th>Destination</th>
          <th>Language</th>
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let value of values" [ngClass]="{'active': rule && rule.id == value.ruleId}">
          <td *ngIf="!mode">&nbsp;</td>
          <td *ngIf="mode">
            <div>
              <div *ngIf="rule">
                <md-checkbox [(ngModel)]="value.selected"></md-checkbox>&nbsp;&nbsp;
              </div>
              <div *ngIf="mode === 'update' && value.ruleId > 0"> Overwrite</div>
              <div *ngIf="mode === 'update' && value.ruleId === 0"> Create</div>
            </div>
          </td>
          <td>
            <div>
              #{{value.ruleId}}
            </div>
          </td>
          <td>{{value.destination}}</td>
          <td>{{value.language.value}}</td>
          <td>
            <a *ngIf="value.ruleId != 0" md-icon-button target="_blank"
              [routerLink]="['', { outlets: { modal: ['edit', 'rule', value.ruleId] } }]">
              <md-icon>open_in_new</md-icon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
    <br>
  </md-dialog-content>
  <md-dialog-actions *ngIf="rule">
    <div class="actions">
      <button md-raised-button md-dialog-close>
        <md-icon>cancel</md-icon>
        Cancel
      </button>
      <button *ngIf="rule && mode === 'update'" md-raised-button color="accent" (click)="update()"
        [disabled]="isSelected() || loading">
        <md-icon>check</md-icon>
        Update selected items
      </button>
      <button *ngIf="rule && mode === 'delete'" md-raised-button color="warn" (click)="delete()"
        [disabled]="isSelected() || loading">
        <md-icon>delete</md-icon>
        Delete selected items
      </button>
    </div>
  </md-dialog-actions>
</div>


// WEBPACK FOOTER //
// ./src/app/modals/rule-duplicate-warning/rule-duplicate-warning.component.html